import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { deleteAdminApplicantsRoute } from '../api/constant';
import { adminApplicantsList } from '../constants';

type useDeleteApplicantProps = {
    setAlertText?: Dispatch<SetStateAction<string>>;
};

export const useDeleteApplicant = ({
    setAlertText = () => { },
}: useDeleteApplicantProps) => {
    const client = useQueryClient();

    const { mutate: deleteApplicant, isLoading: isdeleteApplicantLoading } =
        useMutation({
            mutationFn: (variables: {
                user_id: number | string;
            }) =>
                axiosInstance
                    .post(deleteAdminApplicantsRoute, variables, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                    .then((res) => res.data),
            onSuccess: (data) => {
                client.invalidateQueries([adminApplicantsList]);
                setAlertText('');
            },
            onError: () => {
                setAlertText(errorMessage);
            },
        });
    return {
        deleteApplicant,
        isdeleteApplicantLoading,
    };
};
